import {Input} from "antd";
import {useState, useEffect} from "react";

const ConsumerItem = ({i, consumer, onChangeConsumer, validate}) => {

    const [name, setName] = useState("");
    const [surname, setSurname] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [isValidate, setValidate] = useState(false);

    const formatPhone = (event) => {

        let formatted = '';

        let numbersOnly = event.target?.value.replace(/\D/g, '');

        if (numbersOnly.length > 0) {
            formatted += '+7 ';
        }
        if (numbersOnly.length > 1) {
            formatted += '(' + numbersOnly.substring(1, 4);
        }
        if (numbersOnly.length > 4) {
            formatted += ') ' + numbersOnly.substring(4, 7);
        }
        if (numbersOnly.length > 7) {
            formatted += '-' + numbersOnly.substring(7, 9);
        }
        if (numbersOnly.length > 9) {
            formatted += '-' + numbersOnly.substring(9, 11);
        }

        setPhone(formatted);
    }

    useEffect(() => {
        if (consumer) {
            setName(consumer.name);
            setSurname(consumer.surname);
            setPhone(consumer.phone);
            setEmail(consumer.email);
        }
    }, [])

    useEffect(() => {
        if (validate) {
            setValidate(true);
        }
    }, [validate])

    const onSave = () => {
        console.log("onSave");
        onChangeConsumer(i, {
            surname: surname,
            name: name,
            phone: phone,
            email: email,
        })
        setValidate(true);
    }

    return <div className={'flex mob-block items-center justify-center gap-2 pb-2'}>
        <div className={'w-3/12 flex mob-block mob-w-full items-center'}>
                            <span className={'mob-block mob-w-full-important mob-text-align'} style={{width: '25px'}}>
                                <span className={'desktop-hidden font-bold'}>Доступ №</span>{i + 1}
                            </span>
            <Input className={'mob-w-full mob-mt-1'} status={isValidate && surname.length < 2 ? 'error' : ''} placeholder={'Фамилия *'} value={surname} onKeyUp={onSave}
                   onChange={(e) => setSurname(e.target.value)}/>
        </div>
        <div className={'w-3/12 mob-w-full mob-mt-1'}>
            <Input status={isValidate && name.length < 2 ? 'error' : ''} placeholder={'Имя *'} value={name} onKeyUp={onSave}
                   onChange={(e) => setName(e.target.value)}/>
        </div>
        <div className={'w-3/12 mob-w-full mob-mt-1'}>
            <Input status={isValidate && phone.length < 18 ? 'error' : ''} placeholder={'Номер телефона *'} onKeyUp={onSave} value={phone} onChange={formatPhone}/>
        </div>
        <div className={'w-3/12 mob-w-full mob-mt-1'}>
            <Input placeholder={'E-mail'} value={email} onKeyUp={onSave} onChange={(e) => setEmail(e.target.value)}/>
        </div>
    </div>
}

export default ConsumerItem;
